const collapsibleRows = document.querySelectorAll('collapsible-row-root')
collapsibleRows.forEach(collapsibleRow => {
  const toggle = collapsibleRow.querySelector('button');
  const content = collapsibleRow.querySelector('transition-root');

	toggle.addEventListener('click', ()=>{
		let expanded = toggle.getAttribute('aria-expanded');
    closeAllCollapsible(expanded?toggle:false);
  })
})

function closeAllCollapsible (except) {
	collapsibleRows.forEach(collapsibleRow => {
    const toggle = collapsibleRow.querySelector('button');
  	const content = collapsibleRow.querySelector('transition-root');
		if (toggle !== except){
			toggle.setAttribute('aria-expanded', false);
			content.style.height = 0;
		}
  })
}